module.exports = __webpack_public_path__ + "img/SJGL.f373c6f7.png";